// hooks/useWarning.ts
import { useCallback } from "react";
import { message } from "antd";

export const useMessage = () => {
  const [messageApi, contextHolder] = message.useMessage();

  const showSuccess = useCallback(
    (texto: string | undefined) => {
      messageApi.open({
        type: "success",
        content: texto,
        key: "success",
      });
    },
    [messageApi]
  );

  const showError = useCallback(
    (texto: string | undefined | null) => {
      messageApi.open({
        type: "error",
        content: texto,
        key: "error",
        duration: 5,
      });
    },
    [messageApi]
  );

  const showErrorLong = useCallback(
    (texto: string | undefined | null) => {
      messageApi.open({
        type: "error",
        content: texto,
        key: "error",
        duration: 10,
      });
    },
    [messageApi]
  );

  const showWarning = useCallback(
    (texto: string) => {
      messageApi.open({
        type: "warning",
        content: texto,
        key: "warning",
        duration: 5,
      });
    },
    [messageApi]
  );

  return { showSuccess, showError, showWarning, contextHolder };
};
